import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type Conversion } from 'entities/Conversion'

export class RowConversion extends RowBase<Conversion> {
  constructor(origin: Conversion) {
    super(origin)

    makeObservableRowBase(this)
  }

  get fields() {
    return {
      id: this.origin.id,
      name: this.origin.name,
      conversion_url: this.origin.conversion_url,
      default_value: this.origin.default_value,
      currency: this.origin.currency,
      conversion_rate: this.origin.analytics.conversion_rate,
      conversion_revenue: this.origin.analytics.conversion_value,
    }
  }
}
